import React from 'react';

import ExternalLink from 'flow/components/ui-components/ExternalLink';
import useAppContext from 'flow/hooks/useAppContext';
import { getBrand, getBrandKey } from 'flow/brands/brands';
import { isEtisalatBrand } from 'flow/utils/brand-utils';

// The link is set per brand in Partner (urls.generalPrivacyPolicy on /v2/branding);
// a brand without one gets no row.
const SettingsPrivacyPolicyLink = () => {
    const { i18next } = useAppContext();

    const privacyPolicyUrl = getBrand().brandGeneralPrivacyPolicyUrl;

    if (!privacyPolicyUrl) {
        return null;
    }

    // Etisalat names the row "Privacy & Terms", as the Android app does.
    const title = isEtisalatBrand(getBrandKey())
        ? i18next.t('settings.general.privacy.terms')
        : i18next.t('settings.general.privacy.policy');

    return (
        <ExternalLink href={privacyPolicyUrl} className="py-4">
            {title}
        </ExternalLink>
    );
};

export default SettingsPrivacyPolicyLink;
